import { useState } from "react";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MODULES } from "./Constants";


const MenuNotificaciones = () => {
    const [show, setShow] = useState(true);
    const onShowSidebar = () => setShow(show ? false : true);



    return (
        <>
            <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
            <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
            <div className="custom-wrapper">
                <div className="p-3">
                    <h1 className="title">Módulo de Notificaciones</h1>
                    <div>
                        <p>En esta sección podrás configurar las notificaciones según los módulos disponibles en el sistema.</p>
                        <p>Selecciona el módulo que deseas configurar.</p>
                    </div>
                    <Container fluid className="d-flex flex-wrap justify-content-around mt-4 mb-4">
                        {Object.values(MODULES).map((module, index) => (
                            <Link className="text-decoration-none" to={module.path} key={index}>
                                <div key={index} className="px-4 py-5 mx-2 my-4 border rounded shadow bg-aurora text-white text-center" style={{ width: "300px", cursor: "pointer" }}>
                                    <h5>{module.name}</h5>
                                </div>
                            </Link>

                        ))}
                    </Container>
                </div>
            </div>
        </>
    )
}

export default MenuNotificaciones;